import Axios from '@/axios'




export const setting = function (data={}) {
  return Axios({
    url: '/adminapi/v1/setting',
    method: 'post',
    data,
  })
}
